export var ContextGLTriangleFace;
(function (ContextGLTriangleFace) {
    ContextGLTriangleFace[ContextGLTriangleFace["BACK"] = 0] = "BACK";
    ContextGLTriangleFace[ContextGLTriangleFace["FRONT"] = 1] = "FRONT";
    ContextGLTriangleFace[ContextGLTriangleFace["FRONT_AND_BACK"] = 2] = "FRONT_AND_BACK";
    ContextGLTriangleFace[ContextGLTriangleFace["NONE"] = 3] = "NONE";
})(ContextGLTriangleFace || (ContextGLTriangleFace = {}));
